import React, { createContext, useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const { token } = useAuth();

  const [cartItems, setCartItems] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const navigate = useNavigate();

  // Check if there's an active plan or cartItems on page load
  useEffect(() => {
    const storedPlan = localStorage.getItem("selectedPlan");
    if (storedPlan) {
      setSelectedPlan(JSON.parse(storedPlan));
    }
  }, []);

  const addToCart = useCallback(
    (plan) => {
      setSelectedPlan(plan);
      localStorage.setItem("selectedPlan", JSON.stringify(plan));
      navigate("/checkout");
    },
    [navigate]
  );

  return (
    <CartContext.Provider value={{ cartItems, selectedPlan, addToCart }}>
      {children}
    </CartContext.Provider>
  );
};

export default CartContext;
